import { render } from "./Instructors.vue?vue&type=template&id=a681031a"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Instructors/Instructors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a681031a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a681031a', __exports__)) {
    api.reload('a681031a', __exports__)
  }
  
  module.hot.accept("./Instructors.vue?vue&type=template&id=a681031a", () => {
    api.rerender('a681031a', render)
  })

}


export default __exports__